<template>
<div>
    <Breadcrumbs main="Press Release" title="Press Release Edit" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card v-if="!loading && !error">
                    <div slot="with-padding">
                        <div class="form theme-form">

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <input class="form-control" type="text" placeholder="Enter Law & Policy title" v-model="details.title">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Link</label>
                                        <input class="form-control" type="text" placeholder="Enter Law & Policy title" v-model="details.link">
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="details.date"></datepicker>
                                    </div>
                                </div>
                             
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Image</label>
                                        <div class="flex items-center">
                                            <img v-if="show_image" style="height: 80px;" :src="show_image">
                                            <input :class="details.logo ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="uploadFile">
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Description</label>
                                        <ckeditor :editor="editor" placeholder="Enter description..." v-model="details.short_desc"></ckeditor>
                                    </div>
                                </div>
                            </div>
           
          

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Update</button>
                                        <router-link to="/admin/press-release">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </px-card>
                <px-card v-else>
                    <div slot="with-padding">
                        <loader />
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

    
<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";
import Multiselect from 'vue-multiselect';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import treeVue from '../../advance/tree.vue';
import loader from '../loader/loader.vue'
import {
    myHost
} from '../../../_helpers/host'
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        loader,
    },

    data() {
        return {
            host: myHost.host,
            isDisabled: false,
            editor: ClassicEditor,
            details: {
                title: null,
                link: null,
                date:null,
                short_desc: null,
                logo: null,
            },
            show_image: null,

        };
    },

    watch: {
        pressDetails(oldValue, newValue) {
            this.details.title = this.pressDetails.title ? this.pressDetails.title : null
            this.details.date = this.pressDetails.date ? this.pressDetails.date : null
            this.details.link = this.pressDetails.link ? this.pressDetails.link : null
            this.details.short_desc = this.pressDetails.short_desc ? this.pressDetails.short_desc: null
            this.show_image = this.pressDetails.logo ? this.host + this.pressDetails.logo : null
          

        },
    },

    computed: {
        ...mapState({
            pressDetails: state => state.press.press_detail,
            loading: state => state.press.pressLoading,
            error: state => state.press.pressError,
        }),

    },

    mounted() {
        this.$store.dispatch("press/fetchPressDetail", this.$route.params.slug)
    },

    methods: {

        uploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.details.logo = e.target.result;
            };
        },

        onSubmit() {
            this.isDisabled = true
            if (this.details.date !== null) {
                this.details.date = moment(String(this.details.date)).format("YYYY-MM-DD");
            }

            this.$store.dispatch("press/updatePress", {
                press: this.details,
                id: this.pressDetails.slug
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.isDisabled = false,
                        this.details.title = null,
                        this.details.date = null,
                        this.details.link = null,
                        this.details.short_desc = null,
                        this.details.logo = null,

                        setTimeout(() => {
                            this.$router.push('/admin/press-release')
                        }, 2000)

                } else {
                    this.isDisabled = false
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }

            })
        }
    }
};
</script>
